import { sqScalarRuntimeStore } from '@/core/core.stores';
import { ITEM_TYPES } from '@/trendData/trendData.constants';

/**
 * Overlays the fetched values onto a scalar item so readers see them alongside the item's
 * config. Non-scalar items and scalars with no entry are returned as-is (identity preserved).
 */
export function withScalarValues<T extends { id: string; itemType?: string }>(item: T): T {
  if (item.itemType !== ITEM_TYPES.SCALAR) {
    return item;
  }
  const values = sqScalarRuntimeStore.getState().values[item.id];
  return values ? { ...item, ...values } : item;
}
